module.exports = __webpack_public_path__ + "static/cover-e6e964eb6fc9af19f831b6ad55bbf319.png";